import { DoctrineDetails } from "../apiTypes";

export const DOCTRINE_URL_SCHEMA = "/doctrine/:doctrineSlug";

export function getDoctrineUrl(doctrineSlug: DoctrineDetails["slug"]) {
  return `/doctrine/${doctrineSlug}`;
}
